module.exports = __webpack_public_path__ + "img/ht.049e7e8e.png";